<div class="container pt-5 col-md-9 mx-auto admin">

    <h2>Organizations</h2>
    @for (org of organizations | async; track org) {
    <div class="row">
        <div class="col-md-12">
            <div class="row page-header">
                <div class="col-md-2">
                    <p>{{ org.orgUnitType }}</p>
                    <h4>{{ org.name }}</h4>
                    <small>{{ org.id }}</small></div>
                <div class="col-md-2"><a [routerLink]="['/admin/organization', org.id]"><i class="far fa-cogs"></i>
                        Settings</a>
                </div>
            </div>
        </div>
    </div>
    }
</div>